import Marquee from "react-fast-marquee";

const ITEMS = ["SUCCESS THROUGH QUALITY", "PRECISION", "INNOVATION", "ENGINEERING", "SUPER FINISHERS", "ISO 9001:2015"];

export const EditorialMarquee = ({ className = "" }) => (
    <div className={`border-y border-white/10 py-6 overflow-hidden ${className}`} data-testid="editorial-marquee">
        <Marquee speed={35} gradient={false} pauseOnHover>
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center shrink-0">
                    <span className="font-display font-extrabold text-2xl md:text-4xl tracking-tight text-white/90 mx-8 whitespace-nowrap">
                        {item}
                    </span>
                    <span className="h-2 w-2 bg-sf-green rotate-45 shrink-0" />
                </span>
            ))}
        </Marquee>
    </div>
);
